import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'clientQuotations';
let loaded = loadState(STORE_KEY) || [];

const state = {
	clientQuotations: loaded.clientQuotations || [],
	clientPolicies: loaded.clientPolicies || [],
	clientPolicy: loaded.clientPolicy || {},
	clientRenewal: loaded.clientRenewal,
};

const mutations = {
	SET_QUOTATIONS_DATA(state, quotations) {
		state.clientQuotations = quotations;
		saveState(STORE_KEY, state);
	},
	SET_POLICIES_DATA(state, policies) {
		state.clientPolicies = policies;
		saveState(STORE_KEY, state);
	},
	SET_POLICY_DATA(state, policy) {
		state.clientPolicy = policy;
		saveState(STORE_KEY, state);
	},
};

const actions = {
	setClientPoliciesData({ commit }, data) {
		commit('SET_POLICIES_DATA', data);
	},
	setClientQuotationData({ commit }, data) {
		commit('SET_QUOTATIONS_DATA', data);
	},
	setClientPolicy({ commit }, data) {
		commit('SET_POLICY_DATA', data);
	},
};

const getters = {
	selectPoliciesData: (state) => state.clientPolicies,
	selectQuotationsData: (state) => state.clientQuotations,
	selectClientPolicy: (state) => state.clientPolicy,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
